import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'apiKey', 'clientSecret', 'propertyCode', 'roomType', 'from', 'to',
    'requestInfo', 'requestDisplay', 'responseSection', 'responseDisplay', 'statusBadge'
  ]

  send() {
    const apiKey = this.apiKeyTarget.value.trim()
    const clientSecret = this.clientSecretTarget.value.trim()
    const propertyCode = this.propertyCodeTarget.value.trim()
    const roomType = this.roomTypeTarget.value
    const from = this.fromTarget.value
    const to = this.toTarget.value

    if (!apiKey || !clientSecret || !propertyCode || !from || !to) {
      alert('API Key, Client Secret, property_code, from, to は必須です。')
      return
    }

    const fromISO = new Date(from).toISOString()
    const toISO = new Date(to).toISOString()

    const params = new URLSearchParams({ property_code: propertyCode, from: fromISO, to: toISO })
    if (roomType) params.append('room_type', roomType)

    const url = `/api/external/v1/calculated-data?${params.toString()}`

    const fullUrl = `${window.location.origin}${url}`

    this.requestInfoTarget.classList.remove('hidden')
    this.requestDisplayTarget.textContent =
      `curl -X GET '${fullUrl}' \\\n  -H 'X-API-Key: ${apiKey}' \\\n  -H 'X-Client-Secret: ${clientSecret}' | jq`

    this.responseDisplayTarget.textContent = '送信中...'
    this.responseSectionTarget.classList.remove('hidden')
    this.statusBadgeTarget.textContent = ''
    this.statusBadgeTarget.className = 'px-3 py-1 rounded text-sm font-medium'

    fetch(url, {
      method: 'GET',
      headers: { 'X-API-Key': apiKey, 'X-Client-Secret': clientSecret }
    })
      .then(async (response) => {
        const body = await response.json()
        this.responseDisplayTarget.textContent = JSON.stringify(body, null, 2)
        this.statusBadgeTarget.textContent = `${response.status} ${response.statusText}`

        if (response.ok) {
          this.statusBadgeTarget.classList.add('bg-green-100', 'text-green-800')
        } else {
          this.statusBadgeTarget.classList.add('bg-red-100', 'text-red-800')
        }
      })
      .catch((error) => {
        this.responseDisplayTarget.textContent = `Error: ${error.message}`
        this.statusBadgeTarget.textContent = 'Network Error'
        this.statusBadgeTarget.classList.add('bg-red-100', 'text-red-800')
      })
  }
}
